import { Search } from "lucide-react";

import type { PublicUser } from "../api/types";
import { ThemeSelector } from "./ThemeSelector";

interface TopBarProps {
  user: PublicUser;
  onSearch: () => void;
}

export function TopBar({ user, onSearch }: TopBarProps) {
  const displayName = user.display_name || user.email;
  const fallbackInitial = displayName.charAt(0).toUpperCase();

  return (
    <header className="app-topbar">
      <a href="/" className="brand-lockup">
        <span className="brand-mark">SA</span>
        <span>Stock Assist</span>
      </a>
      <button type="button" className="topbar-search" onClick={onSearch}>
        <Search aria-hidden />
        <span>Search symbols</span>
        <kbd className="topbar-search-kbd">⌘K</kbd>
      </button>
      <div className="account-cluster">
        <ThemeSelector />
        <div className="account-chip">
          {user.avatar_url ? (
            <img src={user.avatar_url} alt="" className="account-avatar" />
          ) : (
            <span className="account-avatar account-avatar-fallback">{fallbackInitial}</span>
          )}
          <span>{displayName}</span>
        </div>
        {/* Full-page POST so the server clears the session and redirects to /login. */}
        <form action="/auth/logout" method="post">
          <button className="text-button" type="submit">
            Sign out
          </button>
        </form>
      </div>
    </header>
  );
}
